import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { MainLayout } from './Components/Layout/MainLayout';
import { HomeLayout } from './Components/Layout/HomeLayout'
import { Login } from './Components/Login';
import { RouteWithLayout } from './Components/RouteWithLayout';
import { EnterPassword } from './Components/EnterPassword';
import { News } from './Components/News';
import { NewVisa } from './Components/NewVisa';
import { MyProfile } from './Components/MyProfile';
import { TrackApplication } from './Components/TrackApplication';
import { TrackStickerVisa } from './Components/TrackStickerVisa';
import { Dashboard } from './Components/Dashboard';
import { EmployeeManagement } from './Components/EmployeeManagement';
import { CreditManagement } from './Components/CreditManagement';
import { PaymentDetails } from './Components/PaymentDetails';
import { OrganizeApplication } from './Components/Organize';
import { ReviewApplicaton } from './Components/Review';
import { SubmitApplication } from './Components/SubmitApplication/';
import { ConfirmPayment } from './Components/ConfirmPayment';
import { VerifyOtp } from './Components/VerifyOtp';
import { EnterEmail } from './Components/EnterEmail';
import { SetPassword } from './Components/SetPassword';
import { EnterNewPassword } from './Components/EnterNewPassword';
import { PaymentSuccess } from './Components/PaymentSuccess/PaymentSuccess';
import { PaymentFailed } from './Components/PaymentFailed/PaymentFailed';
import { PaymentUnresolved } from './Components/PaymentUnresolved/PaymentUnresolved'
import { Checkout } from './Components/Checkout/Checkout'
import { RouteFromSite } from './Components/RouteFromSite/RouteFromSite'
import { Notification } from './Components/Notification/Notification';
import { AdditionalOrganizeApplication } from './Components/Organize/AdditionalOrganizeApplication';
import EnquiryForm from './Components/NewVisa/EnquiryForm/EnquiryForm';
import EnquiryFormSuccessfull from './Components/NewVisa/EnquiryForm/EnquiryFormSuccessfull';
import TrackStickerVisaDetails from './Components/TrackStickerVisa/TrackStickerVisaDetails/TrackStickerVisaDetails';

const Routes = () => {
    return (
        <Switch>
            <Redirect
                exact
                from="/"
                to="/login"
            />
            <RouteWithLayout
                exact
                component={RouteFromSite}
                layout={MainLayout}
                path="/redirect/:origin/:nationality/:travelling_to_identity/:start_date/:end_date/:entry_type/:visa_type/:visa_id/"
            />
            <RouteWithLayout
                exact
                component={Login}
                layout={MainLayout}
                path="/login"
            />
            <RouteWithLayout
                exact
                component={VerifyOtp}
                layout={MainLayout}
                path="/verify-otp"
            />
            <RouteWithLayout
                exact
                component={EnterPassword}
                layout={MainLayout}
                path="/enter-password"
            />
            <RouteWithLayout
                exact
                component={EnterNewPassword}
                layout={MainLayout}
                path="/enter-newpassword"
            />
            <RouteWithLayout
                exact
                component={SetPassword}
                layout={MainLayout}
                path="/set-password"
            />
            <RouteWithLayout
                exact
                component={EnterEmail}
                layout={MainLayout}
                path="/enter-email"
            />
            <RouteWithLayout
                exact
                component={News}
                layout={HomeLayout}
                path="/news"
            />
            <RouteWithLayout
                exact
                component={Dashboard}
                layout={HomeLayout}
                path="/dashboard"
            />
            <RouteWithLayout
                exact
                component={NewVisa}
                layout={HomeLayout}
                path="/new-visa"
            />
            <RouteWithLayout
                exact
                component={OrganizeApplication}
                layout={HomeLayout}
                path="/new-visa/organize"
            />
            <RouteWithLayout
                exact
                component={ReviewApplicaton}
                layout={HomeLayout}
                path="/new-visa/review"
            />
            <RouteWithLayout
                exact
                component={EnquiryForm}
                layout={HomeLayout}
                path="/new-visa/enquiry-form"
            />
            <RouteWithLayout
                exact
                component={EnquiryFormSuccessfull}
                layout={HomeLayout}
                path="/new-visa/enquiry-form/successfull"
            />
            <RouteWithLayout
                exact
                component={SubmitApplication}
                layout={HomeLayout}
                path="/new-visa/submit"
            />
            <RouteWithLayout
                exact
                component={TrackApplication}
                layout={HomeLayout}
                path="/track-application"
            />
            <RouteWithLayout
                exact
                component={TrackStickerVisa}
                layout={HomeLayout}
                path="/track-sticker-visa"
            />
            <RouteWithLayout
                exact
                component={TrackStickerVisaDetails}
                layout={HomeLayout}
                path="/track-sticker-visa/details"
            />
            <RouteWithLayout
                exact
                component={CreditManagement}
                layout={HomeLayout}
                path="/manage-credits"
            />
            <RouteWithLayout
                exact
                component={EmployeeManagement}
                layout={HomeLayout}
                path="/manage-employee"
            />
            <RouteWithLayout
                exact
                component={MyProfile}
                layout={HomeLayout}
                path="/profile"
            />
            <RouteWithLayout
                exact
                component={ConfirmPayment}
                layout={HomeLayout}
                path="/confirm-payment"
            />
            <RouteWithLayout
                exact
                component={PaymentDetails}
                layout={HomeLayout}
                path="/payment-details"
            />
            <RouteWithLayout
                component={Checkout}
                exact
                layout={HomeLayout}
                path="/payment-checkout"
            />
            <RouteWithLayout
                exact
                component={PaymentSuccess}
                layout={HomeLayout}
                path="/payment-success"
            />
            <RouteWithLayout
                exact
                component={PaymentFailed}
                layout={HomeLayout}
                path="/payment-failed"
            />
            <RouteWithLayout
                exact
                component={PaymentUnresolved}
                layout={HomeLayout}
                path="/payment-pending"
            />
            <RouteWithLayout
                exact
                component={Notification}
                layout={HomeLayout}
                path="/notification"
            />
            <RouteWithLayout
                exact
                component={AdditionalOrganizeApplication}
                layout={HomeLayout}
                path="/additional-organize"
            />
        </Switch>
    );
}

export default Routes;